export default String.raw`
{% if settings.compareProducts == 'yes' -%}

    {% assign comparer = comparison-tool -%}
    {% assign products = comparison-tool.Products -%}
    {% assign attributes = comparison-tool.Attributes -%}

    {% assign currency = customer.CurrencyExt.Symbol -%}
    {% assign amount = products.size -%}

    {% assign isEmptyAvailability = 0 -%}
    {% assign isEmptyBrand = 0 -%}
    {% assign isEmptyProductCode = 0 -%}
    {% assign isEmptyVAT = 0 -%}

    {% for product in products -%}
        {% if settings.showAvailabilityStatus == 'no' and product.Availability.Status == 1 -%}
            {% assign isEmptyAvailability = isEmptyAvailability | Plus: 1 -%}
        {% endif -%}

        {% if product.Brand == null or product.Brand == "" -%}
            {% assign isEmptyBrand = isEmptyBrand | Plus: 1 -%}
        {% endif -%}

        {% if product.Code == null or product.Code == "" -%}
            {% assign isEmptyProductCode = isEmptyProductCode | Plus: 1 -%}
        {% endif -%}

        {% if product.VAT == null or product.VAT == "" -%}
            {% assign isEmptyVAT = isEmptyVAT | Plus: 1 -%}
        {% endif -%}
    {% endfor -%}

    {% if customer.Carts[0] or customer.Cart.EditedOrderId -%}
        {% for cart in customer.Carts -%}
            {% if cart.Current -%}
                {% assign currentCartName = cart.Name -%}
            {% endif -%}
        {% endfor -%}
    {% endif -%}

    <div class="comparison__wrapper">
        <div class="comparison">
            {% if amount == 0 %}
            {% else %}
            <div class="comparison__header">
                <h2 class="comparison__header-title">
                    {{translations.ProductsComparison}}
                    <span class="comparison__header-count">({{products.size}})</span>
                </h2>
                {% capture currentPageUrl -%}{% include 'partials/common/user-link.html', userLink: page.Url -%}{% endcapture -%}
                <form class="comparison__header-clear-all clear-comparer-form-js" action="{{ currentPageUrl }}{{ page.QueryString | H }}" method="post">
                    <input type="hidden" name="__action" value="Product/ComparisonToolDelete">
                    {% for product in products -%}
                    <input type="hidden" name="productId" value="{{ product.Id }}">
                    {% endfor -%}
                    <button class="pure-button clear-comparer-js">
                        <svg width="17" height="19.5">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
                        </svg>
                        <span>{{translations.ProductsComparisonRemove}}</span>
                    </button>
                </form>
            </div>
            <div class="comparer comparer-js">
                <div class="comparer__sticky-header comparer-header-js" style="opacity: 0; visibility: hidden;">
                    <section class="table__section top-info">
                        <div class ="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                            </div>
                            <div class="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell swiper-slide">
                                        <div class="table__row-cell-value product-card collapsed">
                                            <a href="{{ page.BaseHref }}{{ product.Url }}" class="product-card__image">
                                                {% if product.ImageId != -1 -%}
                                                    {{product | Img: 'small' }}
                                                {% else -%}
                                                    <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}">
                                                {% endif -%}
                                            </a>
                                            <div class="product-card__info">
                                                <a href="{{ page.BaseHref }}{{ product.Url|H }}" class="product-card__name"> 
                                                    {{product.NameNoHtml | H}}
                                                </a>
                                                {% if customer.HidePrices == true and customer.Authenticated == false -%}
                                                    <!-- Not authenticated - hide -->
                                                    <div class="label sign-in">
                                                        <div class="label__icon">
                                                            <svg width="16" height="19">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
                                                            </svg>
                                                        </div>
                                                        <span class="label__text">{{translations.LogIn}}</span>
                                                    </div>
                                                {% else -%}
                                                    {% if product.AskForPrice == true -%}
                                                    <!-- Hidden prices -->
                                                        <div class="product-card__price-current">&nbsp;</div>
                                                    {% else -%}
                                                    <!-- Default -->
                                                        <b class="product-card__price-current">{{product.Price|ToPrice}}<span class="currency">{{currency}}</span></b>
                                                    {% endif %} 
                                                {% endif -%}
                                            </div>
                                        </div>
                                    </div>
                                    {% endfor -%}
                                </div>
                            </div>
                        </div>
                        <div class="arrow shadowed comparer__slider-button-prev">
                            <svg class="arrow__icon" style="rotate: 180deg;" width="16" height="16">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use>
                            </svg>
                        </div>
                        <div class="arrow shadowed comparer__slider-button-next">
                            <svg class="arrow__icon" width="16" height="16">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use>
                            </svg>
                        </div>
                        <div class="gradient-js"></div>
                    </section>
                </div> 
                <div class="comparer__table">
                    <!-- Top Product Information -->
                    <section class="table__section top-info products comparer-treshold-js">
                        <div class ="table__row">
                            <div class="table__row-cell comparer__table-attribute-name"></div>
                            <div class ="comparer__slider comparer-main-slider-js swiper">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell swiper-slide">
                                        <div class="table__row-cell-value product-card">
                                            <div class="product-card__image-wrapper">
                                                <a href="{{ page.BaseHref }}{{ product.Url }}" class="product-card__image">
                                                    {% if product.ImageId != -1 -%}
                                                        {{product | Img: 'large' }}
                                                    {% else -%}
                                                        <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}">
                                                    {% endif -%}
                                                </a>
                                                <button type="submit" class="product-card__remove remove-from-comparison-js" data-product-id="{{product.Id}}"> 
                                                    <svg width="16" height="16" style="pointer-events: none;">
                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                                    </svg>                             
                                                </button>
                                            </div>
                                            <div class="product-card__info">
                                                <a href="{{ page.BaseHref }}{{ product.Url|H }}" class="product-card__name"> 
                                                    {{product.NameNoHtml | H}}
                                                </a>
                                                {% if customer.HidePrices == true and customer.Authenticated == false -%}
                                                    <!-- Not authenticated - hide -->
                                                    <div class="label sign-in">
                                                        <div class="label__icon">
                                                            <svg width="16" height="19">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
                                                            </svg>
                                                        </div>
                                                        <span class="label__text">{{translations.SignInToSeePrice}}</span>
                                                    </div>
                                                {% else -%}
                                                    {% if product.AskForPrice == true -%}
                                                    <!-- Hidden prices -->
                                                        <div class="product-card__info-group">
                                                            <div class="product-card__prices">
                                                                <b class="product-card__price-current">&nbsp;<span class="currency">&nbsp;</span></b>
                                                            </div>
                                                            {% if settings.lowestProductPrice == 'yes'-%}
                                                            <small class="product-card__price-lowest">
                                                                &nbsp;
                                                            </small>
                                                            {% endif -%}
                                                        </div>
                                                    {% else -%}
                                                    <!-- Default -->
                                                        <div class="product-card__info-group">
                                                            <div class="product-card__prices">
                                                                <b class="product-card__price-current">{{product.Price|ToPrice}}<span class="currency">{{currency}}</span></b>
                                                                {% if product.PreviousPrice != null -%}
                                                                    <s class="product-card__price-previous">
                                                                        {% if product.PreviousPrice > product.Price %}
                                                                            {{product.PreviousPrice|ToPrice}} <span class="currency">{{currency}}</span>
                                                                        {% elseif product.RegularPrice > product.Price and config.ENTERPRISE and settings.minimalPrice == 'minimalPriceNo' %}
                                                                            {{product.RegularPrice|ToPrice}} <span class="currency">{{currency}}</span>
                                                                        {% endif %}
                                                                    </s>
                                                                {% endif %}
                                                            <span class="product-card__price-tax">
                                                                {% if customer.Cart.SubtotalPrices -%}
                                                                    {{translations.Netto | Downcase}}
                                                                {% else -%}
                                                                    {{translations.Brutto | Downcase}}
                                                                {% endif -%}
                                                            </span>
                                                            </div>
                                                            {% if product.DepositValue > 0 -%}
                                                                <small class="product-card__deposit">
                                                                    {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currency }} / {{ product.BasicUnit }}
                                                                </small>
                                                            {% endif -%}
                                                            {% if settings.lowestProductPrice == 'yes'-%}
                                                                <small class="product-card__price-lowest">
                                                                    {% if product.MinPrice != null -%}
                                                                        {{product.MinPrice | Round: config.DecimalPlacesPrice | ToPrice }}
                                                                        <span class="currency">{{currency}}</span>
                                                                        {% if customer.Cart.SubtotalPrices -%}
                                                                            {{translations.Netto | Downcase}}
                                                                        {% else -%}
                                                                            {{translations.Brutto | Downcase}}
                                                                        {% endif -%}
                                                                        {{translations.Price_Omnibus}}
                                                                    {% else -%}
                                                                    &nbsp;
                                                                    {% endif -%}
                                                                </small>
                                                            {% endif -%}
                                                        </div>
                                                    {% endif -%}
                                                {% endif -%}
                                            </div>
                                            <!-- Product card buttons -->
                                            <div class="product-card__buttons">
                                            {% if customer.HidePrices == 'true' and customer.Authenticated == 'false' -%}
                                                {% if settings.signIn == "page" -%}
                                                    <a class="secondary-action-button" aria-label="sign-in" href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" rel="nofollow" title="{{ translations.LogIn }}">
                                                        <span class="button__text">{{translations.LogIn}}</span>
                                                        <div class="button__icon">
                                                            <svg width="18" height="20" >
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                                                            </svg>
                                                        </div>                
                                                    </a>
                                                {% else -%}
                                                    <a class="secondary-action-button show-login-popup-js" aria-label="sign-in" rel="nofollow" title="{{ translations.LogIn }}">
                                                        <span class="button__text">{{translations.LogIn}}</span>
                                                        <div class="button__icon">
                                                            <svg width="18" height="20" >
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                                                            </svg>
                                                        </div>                
                                                    </a>
                                                {% endif -%}
                                            {% else -%}
                                                {% if product.AskForPrice == true -%}
                                                    <div class="button__group form-js add-to-cart-js">
                                                        <input type="hidden" name="productId" value="{{ product.Id }}">
                                                        <input type="hidden" name="quantity" value="1">
                                                        <button class="primary-action-button load-product-presentation-form-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="ask-for-price">
                                                            <span class="button__text">{{translations.AskForPrice}}</span>
                                                            <div class="button__icon">
                                                                <svg width="24" height="24" >
                                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                                                                </svg>
                                                            </div>
                                                        </button>
                                                        {% if customer.Authenticated -%}
                                                            <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button{% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
                                                                <svg class="button__icon" width= "20" height="20">
                                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                                                                </svg>
                                                            </button>
                                                        {% endif -%}
                                                    </div>
                                                    {% elseif product.Availability.Status == 3 and product.HasAttributes == false -%}
                                                    <div class="button__group form-js add-to-cart-js">
                                                        <input type="hidden" name="productId" value="{{ product.Id }}">
                                                        <input type="hidden" name="quantity" value="1">
                                                        <button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="notify-about-availability" title="{{ translations.NotifyAboutAvailability }}">
                                                            <span class="button__text">{{ translations.NotifyAboutAvailability }}</span>
                                                            <svg class="button__icon" width="18" height="20">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
                                                            </svg>
                                                        </button>
                                                        {% if customer.Authenticated -%}
                                                            <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
                                                                <svg class="button__icon" width="24" height="24">
                                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                                                                </svg>                              
                                                            </button>
                                                        {% endif -%}
                                                    </div>
                                                {% elseif product.HasAttributes == true -%}
                                                    <div class="button__group">
                                                        <button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button choose-variant-js">
                                                            <span class="button__text">{{ translations.AvailableProductVariants }}</span>
                                                            <svg class="button__icon">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                {% else -%}
                                                    <div class="button__group form-js add-to-cart-js">
                                                        <input type="hidden" name="__action" value="Cart/Add">
                                                        <input type="hidden" name="productId" value="{{ product.Id }}">
                                                        <input type="hidden" name="quantity" value="1">
                                                        <button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button add-to-cart-update-client-area-js parent-container-reload-js">
                                                            <span class="button__text">{{ translations.ToCart }}</span>
                                                            <svg class="button__icon">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{ settings.iconStyle }}"></use>
                                                            </svg>
                                                        </button>
                                                        {% if usr.Authenticated -%}
                                                        <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}" data-product-id="{{product.Id}}">
                                                            <svg class="button__icon">
                                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{ settings.iconStyle }}"></use>
                                                            </svg>
                                                        </button>
                                                        {% endif -%}
                                                    </div>
                                                {% endif -%}
                                            {% endif -%}
                                            </div>
                                        </div>
                                    </div>
                                    {% endfor %}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value comparer__table-more">
                                                <p class="comparer__table-more-title">{{translations.AddMoreProductsToComparison}}</p>
                                                <a href="{{ page.BaseHref }}{{config.DefinedPages.ProductList.Url}}" class="button">
                                                    <span class="button__text">
                                                        {{translations.GoToProductsList}}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        <div class="arrow shadowed comparer__slider-button-prev">
                            <svg class="arrow__icon" style="rotate: 180deg;" width="16" height="16">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use>
                            </svg>
                        </div>
                        <div class="arrow shadowed comparer__slider-button-next">
                            <svg class="arrow__icon" width="16" height="16">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use>
                            </svg>
                        </div>
                    </section>
                    <!-- Basic Information -->
                    <section class="table__section">
                        <div class="table__row">
                            <div class="table__row-cell full-row comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value">
                                    <h2 class="table__header" title="{{translations.BasicInformation}}">{{translations.BasicInformation}}</h2>
                                </div>
                            </div>
                            <div class ="comparer__slider comparer-slider-js swiper full-row__empty">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell full-row comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value">
                                            &nbsp;
                                        </div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell full-row comparer__table-property-value swiper-slide">
                                            <div class="table__row-cell-value">&nbsp;</div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        <!-- Rating -->
                        {% if config.Reviews.Enabled -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                {{translations.Rating}}
                                </div>
                            </div>
                            <div class ="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value property__rating">
                                            {% for i in (1..5) -%}
                                                {% if product.Rating >= i -%}
                                                <svg width="16" height="16">
                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-solid"></use>
                                                </svg>
                                                {% else -%}
                                                <svg width="16" height="16">
                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-{{settings.iconStyle}}"></use>
                                                </svg>                                       
                                                {% endif -%}
                                            {% endfor -%}
                                            <small class="property__rating-count">({{product.RatingCount}})</small>
                                        </div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value"></div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                        <!-- Availability -->
                        {% if isEmptyAvailability < amount -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                {{translations.Availability}}
                                </div>
                            </div>
                            <div class ="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value property__availability">
                                            {% unless settings.showAvailabilityStatus == 'no' and product.Availability.Status == 1 -%}
                                                {{product.Availability.Text}}
                                            {% endunless -%}
                                        </div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value"></div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                        <!-- Brand -->
                        {% if isEmptyBrand < amount and settings.productDetailsBrand == 'productDetailsBrand-yes' -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                {{translations.Brand}}
                                </div>
                            </div>
                            <div class ="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value property__brand">
                                            {{product.Brand.Name}}
                                        </div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value"></div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                        <!-- Code -->
                        {% if isEmptyProductCode < amount -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                    {{translations.ProductCode}}
                                </div>
                            </div>
                            <div class ="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value property__code">{{product.Code | H}}</div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value"></div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                        <!-- VAT tax -->
                        {% if isEmptyVAT < amount -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                {{translations.VatTax}}
                                </div>
                            </div>
                            <div class ="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value property__vat-tax">{{product.VAT}} %</div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value"></div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                    </section>
                    <!-- Technical parameters -->
                    {% if attributes != null -%}
                    <section class="table__section">
                        <div class="table__row">
                            <div class="table__row-cell full-row comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value">
                                    <h2 class="table__header" title="{{translations.TechnicalParameters}}" >{{translations.TechnicalParameters}}</h2>
                                </div>
                            </div>
                            <div class ="comparer__slider swiper full-row__empty comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell full-row comparer__table-property-value swiper-slide">
                                        <div class="table__row-cell-value">
                                            &nbsp;
                                        </div>
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell full-row comparer__table-property-value swiper-slide">
                                            <div class="table__row-cell-value">&nbsp;</div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        <!-- Parameter -->
                        {% for attribute in attributes -%}

                        {% assign hideAttr = false -%}
                        {% if attribute contains '360photo' -%}
                            {% assign hideAttr = true -%}
                        {% endif -%}

                        {% if hideAttr == false -%}
                        <div class="table__row">
                            <div class="table__row-cell comparer__table-attribute-name">
                                <div class="table__row-cell-value comparer__table-attribute-name-value ">
                                    {{attribute}}
                                </div>
                            </div>
                            <div class="comparer__slider swiper comparer-slider-js">
                                <div class="table__row-cells swiper-wrapper">
                                    {% for product in products -%}
                                    <div class="table__row-cell comparer__table-property-value swiper-slide">
                                        {% assign productAttr = product.Attributes[attribute] -%}
                                        {% if productAttr.size == 0 -%}
                                        <div class="table__row-cell-value property__value">-</div>
                                        {% else -%}
                                        <div class="table__row-cell-value property__value">
                                            {% for attr in productAttr -%}
                                                {% if attr != productAttr.last-%}
                                                    {{attr}},
                                                {% else -%}
                                                    {{attr}}
                                                {% endif -%}
                                            {% endfor -%}
                                        </div>
                                        {% endif -%}
                                    </div>
                                    {% endfor -%}
                                    {% if amount == 1 -%}
                                        <div class="table__row-cell swiper-slide">
                                            <div class="table__row-cell-value">&nbsp;</div>
                                        </div>
                                    {% endif -%}
                                </div>
                            </div>
                        </div>
                        {% endif -%}
                        {% endfor -%}
                    </section>
                    {% endif -%}
                    <div class="gradient-js"></div>
                </div>
            </div>
            {% endif -%}
        </div>
    </div>
{% endif -%}
`